export default {"src":"/_next/static/media/reports-icon.ca1b8e2c.svg","height":32,"width":31,"blurWidth":0,"blurHeight":0};